import { getErpCommonParams } from './tools'
import { ENV } from 'public/config'


export function commonParams () {
  return {
    user_id: getErpCommonParams('__ERPUSER__').id,
    user_agent: navigator.userAgent,
    system_code: '10',
    env_code: ENV || 'dev'
  }
}

export function moduleReport (data, params) {
  const payload = {}
  return {
    payload,
    ...data,
  }
}

export function exposureReport (data, params) {
  const payload = {}
  return {
    payload,
    ...data,
  }
}

export const EventTypeMap = {
  module: 'module',
  exposure: 'exposure'
}
const EventMap = {
  [EventTypeMap.module]: moduleReport,
  [EventTypeMap.exposure]: exposureReport,
}

export function reportEvent (params) {
  const { eventType, componentName, payload } = params
  const data = {
    event_type: eventType,
    component_name: componentName,
    ...payload
  }
  const cb = EventMap[eventType]
  return cb(data, params)
}



// WEBPACK FOOTER //
// ./src/public/mixins/component-report/report-event.js